/**************************************************
 * Nombre:       Detalle_Coleccion_Titulo_Imgs
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import {theme} from "../../../Tema";
import '@splidejs/react-splide/css';
import {useRef} from "react";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";
import {TituloTexto} from "./SubComponentes/TituloTexto";


const Detalle_Categoria_Titulo = ({nombre}) => {
    const refe = useRef(null)
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 6, color: theme.palette.primary.main, mt: 6}}
            >


                <Grid container size={{xs: 12, sm: 12, md: 6}}>
                    <TituloTexto texto={'CATEGORIA'} titulo={nombre}/>
                </Grid>


            </Grid>

        </Grid>


    )

}
export default Detalle_Categoria_Titulo

